import React, { useEffect, useState } from "react";
import NavBar from "../components/NavBar";
import { logout } from "../features/authSlice";
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import HomeRoutes from "../layout/HomeRoutes";
import Footer from "../components/Footer";

const DashboardLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state.auth.user); // Traemos al usuario del estado global

  const tokenExp = localStorage.getItem("tokenExp"); // Se extrae el token del localStorage

  const [redirect, setRedirect] = useState(false); // Estado para redirijir al usuario al login en caso no esté logeado

  const isTokenExpired = () => {
    // Verifica si el token expiró
    const expTime = tokenExp;
    if (!expTime) return true;
    const currentTime = Math.floor(Date.now() / 1000);
    return parseInt(expTime) < currentTime;
  };

  const handleLogout = async () => {
    // Funcion para despachar el deslogueo al estado global y redirigir al login
    dispatch(logout());
    setRedirect(true);
  };

  useEffect(() => {
    // Si el token expira se le envía al usuario al login (Cada token dura 96 horas)
    if (isTokenExpired()) {
      dispatch(logout());
      navigate("/");
    }
  }, []);

  if (redirect) {
    // Si se deslogea se le envía al usuario a login
    return <Navigate to={"/"} />;
  }

  if (user == null) {
    // Si no hay usuario logeado se le envía al login
    return <Navigate to={"/"} />;
  }

  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* La NavBar aparecerá en todas las rutas */}
      <NavBar handleLogout={handleLogout} />
      {/*space for navbar*/}
      <div className="pt-[70px] flex-1 pb-16">
        <HomeRoutes />
      </div>
      <Footer />
    </div>
  );
};

export default DashboardLayout;
